/**
 * sign 是服务器推过来
 * code 是客户端发给服务器
 */
export const emoji = [
    { uri: require('../img/emoji/00.png'), sign: '[微笑]', code: '/::)' },
    { uri: require('../img/emoji/01.png'), sign: '[撇嘴]', code: '/::~' },
    { uri: require('../img/emoji/02.png'), sign: '[色]', code: '/::B' },
    { uri: require('../img/emoji/03.png'), sign: '[发呆]', code: '/::|' },
    { uri: require('../img/emoji/04.png'), sign: '[得意]', code: '/:8-)' },
    { uri: require('../img/emoji/05.png'), sign: '[流泪]', code: '/::<' },
    { uri: require('../img/emoji/06.png'), sign: '[害羞]', code: '/::$' },
    { uri: require('../img/emoji/07.png'), sign: '[闭嘴]', code: '/::X' },
    { uri: require('../img/emoji/08.png'), sign: '[睡]', code: '/::Z' },
    { uri: require('../img/emoji/09.png'), sign: '[大哭]', code: '/::\'(' },
    { uri: require('../img/emoji/10.png'), sign: '[尴尬]', code: '/::-|' },
    { uri: require('../img/emoji/11.png'), sign: '[发怒]', code: '/::@' },
    { uri: require('../img/emoji/12.png'), sign: '[调皮]', code: '/::P' },
    { uri: require('../img/emoji/13.png'), sign: '[呲牙]', code: '/::D' },
    { uri: require('../img/emoji/14.png'), sign: '[惊讶]', code: '/::O' },
    { uri: require('../img/emoji/15.png'), sign: '[难过]', code: '/::(' },
    { uri: require('../img/emoji/17.png'), sign: '[囧]', code: '[囧]' },
    { uri: require('../img/emoji/18.png'), sign: '[抓狂]', code: '/::Q' },
    { uri: require('../img/emoji/19.png'), sign: '[吐]', code: '/::T' },
    { uri: require('../img/emoji/20.png'), sign: '[偷笑]', code: '/:,@P' },
    { uri: require('../img/emoji/21.png'), sign: '[愉快]', code: '/:,@-D' },
    { uri: require('../img/emoji/22.png'), sign: '[白眼]', code: '/::d' },
    { uri: require('../img/emoji/23.png'), sign: '[傲慢]', code: '/:,@o' },
    { uri: require('../img/emoji/25.png'), sign: '[困]', code: '/:|-)' },
    { uri: require('../img/emoji/26.png'), sign: '[惊恐]', code: '/::!' },
    { uri: require('../img/emoji/27.png'), sign: '[流汗]', code: '/::L' },
    { uri: require('../img/emoji/28.png'), sign: '[憨笑]', code: '/::>' },
    { uri: require('../img/emoji/29.png'), sign: '[悠闲]', code: '/::,@' },
    { uri: require('../img/emoji/30.png'), sign: '[奋斗]', code: '/:,@f' },
    { uri: require('../img/emoji/31.png'), sign: '[咒骂]', code: '/::-S' },
    { uri: require('../img/emoji/32.png'), sign: '[疑问]', code: '/:?' },
    { uri: require('../img/emoji/33.png'), sign: '[嘘]', code: '/:,@x' },
    { uri: require('../img/emoji/34.png'), sign: '[晕]', code: '/:,@@' },
    { uri: require('../img/emoji/36.png'), sign: '[衰]', code: '/:,@!' },
    { uri: require('../img/emoji/37.png'), sign: '[骷髅]', code: '/:!!!' },
    { uri: require('../img/emoji/38.png'), sign: '[敲打]', code: '/:xx' },
    { uri: require('../img/emoji/39.png'), sign: '[再见]', code: '/:bye' },
    { uri: require('../img/emoji/40.png'), sign: '[擦汗]', code: '/:wipe' },
    { uri: require('../img/emoji/41.png'), sign: '[抠鼻]', code: '/:dig' },
    { uri: require('../img/emoji/42.png'), sign: '[鼓掌]', code: '/:handclap' },
    { uri: require('../img/emoji/44.png'), sign: '[坏笑]', code: '/:B-)' },
    { uri: require('../img/emoji/45.png'), sign: '[左哼哼]', code: '/:<@' },
    { uri: require('../img/emoji/46.png'), sign: '[右哼哼]', code: '/:@>' },
    { uri: require('../img/emoji/47.png'), sign: '[哈欠]', code: '/::-O' },
    { uri: require('../img/emoji/48.png'), sign: '[鄙视]', code: '/:>-|' },
    { uri: require('../img/emoji/49.png'), sign: '[委屈]', code: '/:P-(' },
    { uri: require('../img/emoji/50.png'), sign: '[快哭了]', code: '/::\'|' },
    { uri: require('../img/emoji/51.png'), sign: '[阴险]', code: '/:X-)' },
    { uri: require('../img/emoji/52.png'), sign: '[亲亲]', code: '/::*' },
    { uri: require('../img/emoji/54.png'), sign: '[可怜]', code: '/:8*' },
    { uri: require('../img/emoji/55.png'), sign: '[菜刀]', code: '/:pd' },
    { uri: require('../img/emoji/56.png'), sign: '[西瓜]', code: '/:<W>' },
    { uri: require('../img/emoji/57.png'), sign: '[啤酒]', code: '/:beer' },
    { uri: require('../img/emoji/60.png'), sign: '[咖啡]', code: '/:coffee' },
    { uri: require('../img/emoji/62.png'), sign: '[猪头]', code: '/:pig' },
    { uri: require('../img/emoji/63.png'), sign: '[玫瑰]', code: '/:rose' },
    { uri: require('../img/emoji/64.png'), sign: '[凋谢]', code: '/:fade' },
    { uri: require('../img/emoji/116.png'), sign: '[嘴唇]', code: '/:showlove' },
    { uri: require('../img/emoji/66.png'), sign: '[爱心]', code: '/:heart' },
    { uri: require('../img/emoji/67.png'), sign: '[心碎]', code: '/:break' },
    { uri: require('../img/emoji/68.png'), sign: '[蛋糕]', code: '/:cake' },
    { uri: require('../img/emoji/70.png'), sign: '[炸弹]', code: '/:bome' },
    { uri: require('../img/emoji/74.png'), sign: '[便便]', code: '/:shit' },
    { uri: require('../img/emoji/75.png'), sign: '[月亮]', code: '/:moon' },
    { uri: require('../img/emoji/76.png'), sign: '[太阳]', code: '/:sun' },
    { uri: require('../img/emoji/78.png'), sign: '[拥抱]', code: '/:hug' },
    { uri: require('../img/emoji/79.png'), sign: '[强]', code: '/:strong' },
    { uri: require('../img/emoji/80.png'), sign: '[弱]', code: '/:weak' },
    { uri: require('../img/emoji/81.png'), sign: '[握手]', code: '/:share' },
    { uri: require('../img/emoji/82.png'), sign: '[胜利]', code: '/:v' },
    { uri: require('../img/emoji/83.png'), sign: '[抱拳]', code: '/:@)' },
    { uri: require('../img/emoji/84.png'), sign: '[勾引]', code: '/:jj' },
    { uri: require('../img/emoji/85.png'), sign: '[拳头]', code: '/:@@' },
    { uri: require('../img/emoji/89.png'), sign: '[OK]', code: '/:ok' },
    { uri: require('../img/emoji/92.png'), sign: '[跳跳]', code: '/:jump' },
    { uri: require('../img/emoji/93.png'), sign: '[发抖]', code: '/:shake' },
    { uri: require('../img/emoji/94.png'), sign: '[怄火]', code: '/:<O>' },
    { uri: require('../img/emoji/95.png'), sign: '[转圈]', code: '/:circle' },
    { uri: require('../img/emoji/wx1.png'), sign: '[哈哈]', code: '😄' },
    { uri: require('../img/emoji/wx2.png'), sign: '[生病]', code: '😷' },
    { uri: require('../img/emoji/wx3.png'), sign: '[笑哭]', code: '😂' },
    { uri: require('../img/emoji/wx4.png'), sign: '[可爱]', code: '😝' },
    { uri: require('../img/emoji/wx5.png'), sign: '[呆住]', code: '😳' },
    { uri: require('../img/emoji/wx6.png'), sign: '[惊吓]', code: '😱' },
    { uri: require('../img/emoji/wx7.png'), sign: '[失望]', code: '😔' },
    { uri: require('../img/emoji/wx8.png'), sign: '[无语]', code: '😒' },
    { uri: require('../img/emoji/wx9.png'), sign: '[嘿]', code: '[Hey]' },
    { uri: require('../img/emoji/wx10.png'), sign: '[捂脸]', code: '[Facepalm]' },
    { uri: require('../img/emoji/wx11.png'), sign: '[傻笑]', code: '[Smirk]' },
    { uri: require('../img/emoji/wx12.png'), sign: '[聪明]', code: '[Smart]' },
    { uri: require('../img/emoji/wx13.png'), sign: '[关心]', code: '[Concerned]' },
    { uri: require('../img/emoji/wx14.png'), sign: '[欧耶]', code: '[Yeah!]' },
    { uri: require('../img/emoji/wx15.png'), sign: '[鬼]', code: '👻' },
    { uri: require('../img/emoji/wx16.png'), sign: '[谢谢]', code: '🙏' },
    { uri: require('../img/emoji/wx17.png'), sign: '[肌肉]', code: '💪' },
    { uri: require('../img/emoji/wx18.png'), sign: '[欢迎]', code: '🎉' },
    { uri: require('../img/emoji/wx19.png'), sign: '[礼物]', code: '🎁' },
    { uri: require('../img/emoji/wx20.png'), sign: '[红包]', code: '[Packet]' },
    { uri: require('../img/emoji/wx21.png'), sign: '[发]', code: '[發]' },
    { uri: require('../img/emoji/wx22.png'), sign: '[小狗]', code: '[小狗]' },
]
